var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewStudentsAssigned = function SvgNewStudentsAssigned(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 81,
    viewBox: "0 0 92 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 31.3539C54.6338 31.3539 61.6328 24.3351 61.6328 15.677C61.6328 7.01882 54.6338 0 46 0C37.3662 0 30.3672 7.01882 30.3672 15.677C30.3672 24.3351 37.3662 31.3539 46 31.3539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.625 31.3538C83.0831 31.3538 87.5078 26.9166 87.5078 21.443C87.5078 15.9695 83.0831 11.5323 77.625 11.5323C72.1669 11.5323 67.7422 15.9695 67.7422 21.443C67.7422 26.9166 72.1669 31.3538 77.625 31.3538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 31.3538C19.8331 31.3538 24.2578 26.9166 24.2578 21.443C24.2578 15.9695 19.8331 11.5323 14.375 11.5323C8.91687 11.5323 4.49219 15.9695 4.49219 21.443C4.49219 26.9166 8.91687 31.3538 14.375 31.3538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1123 40.2538C20.222 37.0575 16.6989 37.4806 12.2008 37.4806C5.47328 37.4806 0 42.9369 0 49.6419V69.3211C0 72.233 2.37008 74.6008 5.28461 74.6008C17.8674 74.6008 16.3516 74.8291 16.3516 74.0566C16.3516 60.112 14.7045 49.8857 24.1123 40.2538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2784 37.5525C42.4217 36.8953 35.5927 37.5601 29.7023 42.4358C19.8452 50.3535 21.7422 61.0144 21.7422 74.0564C21.7422 77.507 24.5417 80.3668 28.0348 80.3668C65.9636 80.3668 67.4732 81.5938 69.7223 76.599C70.46 74.9098 70.2578 75.4466 70.2578 59.2876C70.2578 46.453 59.1759 37.5525 50.2784 37.5525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7992 37.4804C75.2765 37.4804 71.7728 37.0616 67.8877 40.2536C77.2252 49.814 75.6484 59.3426 75.6484 74.0564C75.6484 74.8338 74.3901 74.6006 86.5267 74.6006C89.5455 74.6006 92 72.1481 92 69.1335V49.6418C92 42.9367 86.5267 37.4804 79.7992 37.4804Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewStudentsAssigned);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "new-students-assigned.ab468ff355d9296d495d1f7fef2f1ca6.svg";